// Initialize mobile menu
(function() {
    // Mobile Menu Trigger
    var burger = document.querySelector('.gh-burger');
    if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.addEventListener('click', function() {
            var isOpen = document.body.classList.toggle('gh-head-open');
            burger.setAttribute('aria-expanded', String(isOpen));
        });
    }
})();

// Apply stable Spinzo accents to feed cards from their primary tag.
(function() {
    var cards = document.querySelectorAll(':is(.home-template, .tag-template) .post-card[data-primary-tag]');
    if (!cards.length) {
        return;
    }

    var palette = [
        {accent: '#0874C7', light: '#BCD4F6', soft: '#EAF2FF'},
        {accent: '#EB5A5A', light: '#F4B8B8', soft: '#FBEAEA'},
        {accent: '#FF8E17', light: '#FFD9A6', soft: '#FFF2DF'},
        {accent: '#35A852', light: '#C4EBC2', soft: '#EDF8EA'},
        {accent: '#7E3BB8', light: '#D8B8EA', soft: '#F3EAF9'},
        {accent: '#0A9EAA', light: '#B8E3DC', soft: '#E8F7F5'}
    ];

    var isHexColor = function(color) {
        return /^#(?:[0-9a-f]{3}){1,2}$/i.test(color);
    };

    var hash = function(value) {
        var result = 0;
        for (var i = 0; i < value.length; i += 1) {
            result = ((result << 5) - result) + value.charCodeAt(i);
            result |= 0;
        }
        return Math.abs(result);
    };

    var applyAccent = function(card) {
        if (card.dataset.accentReady) {
            return;
        }

        var tagAccent = card.dataset.tagAccent;
        var tagSlug = card.dataset.primaryTag || '';

        if (tagAccent && isHexColor(tagAccent)) {
            card.style.setProperty('--post-accent', tagAccent);
            card.style.setProperty('--post-accent-light', 'color-mix(in srgb, ' + tagAccent + ' 34%, white)');
            card.style.setProperty('--post-accent-soft', 'color-mix(in srgb, ' + tagAccent + ' 12%, white)');
            card.dataset.accentReady = 'true';
            return;
        }

        var color = palette[hash(tagSlug) % palette.length];
        card.style.setProperty('--post-accent', color.accent);
        card.style.setProperty('--post-accent-light', color.light);
        card.style.setProperty('--post-accent-soft', color.soft);
        card.dataset.accentReady = 'true';
    };

    cards.forEach(applyAccent);

    var feed = document.querySelector(':is(.home-template, .tag-template) .post-feed');
    if (!feed || !window.MutationObserver) {
        return;
    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) {
                    return;
                }

                if (node.matches && node.matches('.post-card[data-primary-tag]')) {
                    applyAccent(node);
                    return;
                }

                if (node.querySelectorAll) {
                    node.querySelectorAll('.post-card[data-primary-tag]').forEach(applyAccent);
                }
            });
        });
    });

    observer.observe(feed, {childList: true});
})();
